import React, { useMemo } from 'react';
import { FieldInput, FormCol } from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col } from 'react-bootstrap';
import { FieldSelectCollector, FieldSelectSeriesType } from 'shared-pages/components';
import {
  Company,
  CurrentAppCompany,
  isFotokiklosi,
  isRebattery,
  isRebatteryLiion,
} from 'shared-pages/common/constants';

export const FormFields = ({ isNew, updateRecord, refetch, data }) => {
  //
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx;
  const { appStore } = useRootStore();

  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  const { canEdit, canEditReasoning } = useMemo(() => {
    // A series can only be edited if it has not been used yet (lastNumber is null/undefined)
    const lastNumber = data?.edocSeriesNumbers?.[0]?.lastNumber;
    const isUnused = !lastNumber;

    // Define allowed User roles by company.
    // If a company is not listed, it falls back to the default permission rule.
    const companyRules: Record<string, boolean> = {
      [Company.Rebattery]: appStore.isPlatformOwner,
      [Company.RebatteryLiion]: appStore.isPlatformOwner,
      [Company.Fotokiklosi]: appStore.isPlatformOwner,
      // You can easily add other companies here:
      // [Company.AfisCyprus]: appStore.isPlatformOwner || appStore.isCollector,
    };

    const isUserAllowed =
      CurrentAppCompany in companyRules
        ? companyRules[CurrentAppCompany]
        : appStore.isPlatformOwner || appStore.isCollector; // Default fallback

    const canEdit = isUnused && isUserAllowed;
    const canEditReasoning = '';

    return { canEdit, canEditReasoning };
  }, [data, isNew, appStore.isPlatformOwner, appStore.isCollector]);

  return (
    <>
      <div className="d-flex flex-row">
        {/* 1η Στήλη */}
        <FormCol>
          <FieldInput label={t('Πρόθεμα')} name="docPrefix" placeholder="" disabled={!canEdit} />
          <FieldSelectSeriesType disabled={!canEdit} required />
          <FieldSelectCollector
            disabled={!canEdit}
            label={t('Συλλέκτης')}
            name="collectorId"
            required
          />

          <FieldInput
            label={t('Περιγραφή Σειράς')}
            name="name"
            placeholder=""
            disabled={!canEdit}
            required
          />
        </FormCol>

        {/* 2η Στήλη */}
        <FormCol>
          <FieldInput
            as={Col}
            label={t('Αριθμός Έναρξης')}
            name="startNumber"
            placeholder=""
            disabled={!canEdit}
            required
          />
          {/* {dateField(t('Λήξη Άδειας'), 'licenseExpDate', t, canEdit)} */}
          {/* <FormRow className="mb-2 pb-2" style={{ minHeight: '41.16px' }}></FormRow> */}

          <FieldInput
            as={Col}
            label={t('Αριθμός Λήξης')}
            name="endNumber"
            placeholder=""
            disabled={!canEdit}
            required
          />
          <FieldInput
            as={Col}
            label={t('Τελευταίος Αριθμός')}
            name="edocSeriesNumbers[0].lastNumber"
            placeholder=""
            disabled={true}
            canEdit={canEdit}
          />
          <FieldInput
            as={Col}
            label={t('Τελευταίος Κωδικός')}
            name="edocSeriesNumbers[0].lastCode"
            placeholder=""
            disabled={true}
          />
        </FormCol>

        {/* 3η Στήλη */}
        {/* <FormCol>

        </FormCol> */}

        {/* 4η Στήλη */}
        <FormCol>{isActiveField(t, canEdit)}</FormCol>
      </div>
    </>
  );
};
